export default __webpack_public_path__ + "static/media/VAT.ba13a3d2.svg";